<template>
  <b-container v-if="projectList.length > 0" fluid>
    <b-row>
      <b-col cols="8">
        <h4 class="about-title">{{ ls_OurProducts }}</h4>
        <div class="projects-accordion" role="tablist">
          <b-card
            no-body
            v-for="(project, index) in projectList.filter(p => p.contentType === 'text')"
            :key="index"
            class="accordion-card">
            <b-card-header
              header-tag="header"
              role="tab"
              class="accordion-header">
              <h4
                class="accordion-title"
                v-b-toggle="'accordion' + index"
                variant="info">
                <!-- <span class="accordion-index">{{ index + 1 }}</span> -->
                {{ project.title }}
                <i class="fas fa-chevron-down accordion-down-icon"></i>
              </h4>
            </b-card-header>
            <b-collapse
              :id="'accordion' + index"
              visible
              accordion="my-accordion"
              role="tabpanel"
              class="accordion-content">
              <b-card-body class="accordion-body">
                <div class="card-text accordion-card-content" v-html="replaceImage(project.content)"></div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="sidebar-banner">
          <b-link :href="host + '/ads/show/16.html'" target="_blank" class="sidebar-banner-link">
            <img :src="host + '/ads/show/16.png'" alt="xxx">
          </b-link>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row class="iframe-container">
      <b-col class="iframe-content"
        v-for="(frame, index) in projectList.filter(p => p.contentType === 'video')"
        :key="index"
        cols="3"
        v-html="frame.content">
      </b-col>
    </b-row> -->
    <b-row v-if="projectList.filter(p => p.contentType === 'video').length > 0">
      <b-col>
        <div class="iframe-container">
          <swiper
            :options="swiperOption">
            <swiper-slide
              v-for="(frame, index) in projectList.filter(p => p.contentType === 'video')"
              :key="index">
              <div class="iframe-content"
                v-html="frame.content">
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },

      projectList: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_OurProducts() {
      return this.$store.state.languagePack.ls_OurProducts;
    }
  },

  created() {
    this.getProjectList();
  },

  methods: {
    replaceImage(content) {
      return content.replace(
        "/uploads/images/",
        this.host + "/uploads/images/"
      ).replace(". png", ".png").replace(". jpg", ".jpg").replace(". jpeg", ".jpeg");
    },

    getProjectList() {
      this.$store.state.loading = true;
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getprojectslist", fd)
        .then(result => {
          this.$store.state.loading = false;
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.projectList = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getProjectList();
      }
    }
  },

  metaInfo() {
    return {
      title: this.ls_OurProducts
    };
  }
};
</script>

<style lang="scss" scoped>
.projects-title {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  color: #038395;
  margin-bottom: 0.75rem;
}
.projects-accordion {
  .accordion-card {
    border-radius: 0;
    border: 0;
    background-color: transparent;
    margin-bottom: 0.5rem;

    .accordion-header {
      padding: 0.25rem 1rem 0 0.5rem;
      background-color: #ffffff;
      border: 1px solid #ededed;
      border-radius: 3px;

      &:hover {
        background-color: #f0f8f9;
      }

      .accordion-title.collapsed .accordion-down-icon {
        transform: rotate(0deg);
      }

      .accordion-title {
        position: relative;
        margin: 0.25rem 0 0.5rem 0;
        color: #333333;
        font-size: 16px;
        line-height: 18px;
        padding: 0 15px;
        min-height: 38px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

        .accordion-index {
          position: absolute;
          top: 0;
          left: 0;
          display: inline-block;
          width: 38px;
          height: 38px;
          background-color: #03849020;
          border-radius: 8px;
          text-align: center;
          line-height: 36px;
          color: #038490;
          font-size: 22px;
        }

        .accordion-down-icon {
          position: absolute;
          top: 8px;
          right: 0;
          transform: rotate(-180deg);
          color: #212525;
          font-size: 20px;
          transition: all 0.7s;
        }
      }
    }

    .accordion-content {
      border: 1px solid #ededed;
      background-color: #ffffff;
      margin-top: 0.5rem;

      .accordion-body {
        color: #686868;
        font-size: 16px;

        .img-shape {
          float: left;
          padding-right: 1rem;
        }
      }
    }
  }
}

.iframe-container {
  margin-top: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;

  .swiper-container {
    padding-bottom: 2rem;
  }
}

/* RTL */

.rtl-layout {
  .accordion-title {
    direction: rtl;
    text-align: right;
    line-height: 22px !important;

    .accordion-index {
      right: 0;
      left: calc(100% - 25px) !important;
      line-height: 48px !important;
    }

    .accordion-down-icon {
      left: 0 !important;
      right: calc(100% - 25px) !important;
    }
  }

  .accordion-title.collapsed {
    .accordion-down-icon {
      left: 0 !important;
      right: calc(100% - 25px) !important;
    }
  }

  .accordion-content {
    direction: rtl;
    text-align: right;
  }
}
</style>

<style>
.projects-accordion .accordion-header .accordion-title {
  font-weight: 600 !important;
}
.accordion-card-content p {
  margin-bottom: 4px !important;
}
.iframe-content iframe {
  min-width: 80% !important;
  min-height: 80% !important;
  max-width: 100%;
  max-height: 12rem;
}

.iframe-content iframe img {
  max-width: 100% !important;
  height: auto !important;
}

.iframe-content iframe video {
  max-width: 100% !important;
  height: auto !important;
}
.accordion-content .card-text img[style*="left"] {
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.accordion-content .card-text img[style*="right"] {
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.accordion-content .card-text * {
  text-indent: 1rem;
  text-align: justify;
}
</style>
